<div>
  <i
    [ngClass]="{
      'bi bi-star-fill': rating >= 1,
      'bi bi-star-half': rating === 0.5,
      'bi bi-star': rating < 0.5
    }"
  ></i>
  <i
    [ngClass]="{
      'bi bi-star-fill': rating >= 2,
      'bi bi-star-half': rating === 1.5,
      'bi bi-star': rating < 1.5
    }"
  ></i>
  <i
    [ngClass]="{
      'bi bi-star-fill': rating >= 3,
      'bi bi-star-half': rating === 2.5,
      'bi bi-star': rating < 2.5
    }"
  ></i>
  <i
    [ngClass]="{
      'bi bi-star-fill': rating >= 4,
      'bi bi-star-half': rating === 3.5,
      'bi bi-star': rating < 3.5
    }"
  ></i>
  <i
    [ngClass]="{
      'bi bi-star-fill': rating >= 5,
      'bi bi-star-half': rating === 4.5,
      'bi bi-star': rating < 4.5
    }"
  ></i>
</div>
